import LetterAvatar from "@/components/Avatar/LetterAvatar"
import StatusBadge from "@/components/ui/badge"

export const columns = [
  {
    header: "Code",
    accessorKey: "code",
  },
  {
    header: "Product",
    cell: ({ row }) => row.original?.name,
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
  },
  {
    header: "Type",
    cell: ({ row }) => <StatusBadge name={row.original.type?.name ?? "-"} />,
  },
  {
    header: "Reason",
    cell: ({ row }) => row.original.reason?.name ?? "-",
  },
]
